import React, { useEffect, useState } from "react";
import { Modal, Table, Spin, Empty } from "antd";
import { toast } from "react-toastify";
import { getAjustesConciliadorBancario, AjusteConciliadorBancario } from "../../service/ConciliadorBancarioService";

interface ModalAjustesProps {
  open: boolean;
  onClose: () => void;
  adquirente: string | null;
  cnpj: string | null;
  dataPgto: string | null;
}

const formatCurrencyBR = (value?: string) => {
  const n =
    typeof value === "string"
      ? parseFloat(value.replace(/\./g, "").replace(",", ".")) || 0
      : 0;
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

const ModalAjustes: React.FC<ModalAjustesProps> = ({ open, onClose, adquirente, cnpj, dataPgto }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [ajustes, setAjustes] = useState<AjusteConciliadorBancario[]>([]);

  useEffect(() => {
    if (!open || !adquirente || !cnpj || !dataPgto) return;

    let ativo = true;
    setIsLoading(true);
    getAjustesConciliadorBancario(adquirente, cnpj, dataPgto)
      .then((res) => {
        if (ativo) setAjustes(res);
      })
      .catch(() => {
        if (ativo) {
          setAjustes([]);
          toast.error("Erro ao carregar os ajustes.");
        }
      })
      .finally(() => {
        if (ativo) setIsLoading(false);
      });

    return () => {
      ativo = false;
    };
  }, [open, adquirente, cnpj, dataPgto]);

  const columns = [
    { title: "DATA", dataIndex: "dataLancamento", key: "dataLancamento", width: 110 },
    { title: "TIPO", dataIndex: "tipoLancamento", key: "tipoLancamento", width: 70 },
    {
      title: "VALOR",
      dataIndex: "valor",
      key: "valor",
      width: 130,
      render: (v: string) => (
        <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>{formatCurrencyBR(v)}</div>
      ),
    },
    { title: "MOTIVO", dataIndex: "motivo", key: "motivo" },
    { title: "NSU/CV", dataIndex: "nsucv", key: "nsucv", width: 120 },
    { title: "AUTORIZAÇÃO", dataIndex: "codigoDeAutorizacao", key: "codigoDeAutorizacao", width: 130 },
    { title: "PARCELA", dataIndex: "numeroDaParcela", key: "numeroDaParcela", width: 90 },
    { title: "TID", dataIndex: "tid", key: "tid", width: 150 },
  ];

  const cnpjFmt = cnpj
    ? cnpj.replace(/\D/g, "").replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5")
    : "";
  const dataFmt = dataPgto
    ? (() => {
        const [y, m, d] = dataPgto.split("-");
        return d && m && y ? `${d}/${m}/${y}` : dataPgto;
      })()
    : "";

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width="90vw"
      bodyStyle={{ maxHeight: "75vh", overflow: "auto" }}
      title={`Ajustes: ${adquirente ?? ""} • ${cnpjFmt} • ${dataFmt}`}
    >
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : ajustes.length === 0 ? (
        <Empty description="Nenhum ajuste vinculado a este registro." />
      ) : (
        <Table
          columns={columns}
          dataSource={ajustes.map((a, i) => ({ ...a, key: i }))}
          pagination={false}
          size="small"
          scroll={{ x: "max-content", y: "60vh" }}
        />
      )}
    </Modal>
  );
};

export default ModalAjustes;
